<template>
    <button
        type="button"
        @click.prevent="toggleFavorite()"
        class="h-full w-full bg-white shadow justify-center items-center gap-2.5 flex"
        :class="{
            'rounded-full': shape === 'circle',
            'rounded border border-slate-200': shape === 'square',
            'hover:bg-slate-200 active:outline-slate-200 active:ring-0 focus:outline-slate-200 focus:ring-0':
                shape === 'square',
            'active:outline-none active:ring-0 focus:outline-slate-200 focus:ring-0':
                shape === 'circle',
        }"
        tabindex="0"
    >
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="states"
        >
            <path
                d="M9.99902 5.22362C15.134 0.015136 23.9367 9.68805 9.99906 17.5C-3.93867 9.68808 4.86405 0.0151348 9.99902 5.22362Z"
                stroke-width="1.66667"
                stroke-linejoin="round"
            />
        </svg>
    </button>
</template>
<script>
import { computed } from 'vue';
import { useHotelsStore } from '@/store/hotels';
export default {
    emits: ['removeFav'],
    props: {
        shape: { type: String, default: 'circle' },
        property: Object,
        isWidget: Boolean,
        indie: { type: Boolean, default: false },
        // if !indie, toggling favorite will trigger re-fetch of user's favorites
    },
    setup(props, { emit }) {
        const hotelsStore = useHotelsStore();

        const computedProperty = computed(() => {
            return props.property ? props.property : hotelsStore.property;
        });

        const states = computed(() => {
            return computedProperty.value.isFavorite
                ? 'fill-orange-600 hover:fill-red-400 stroke-orange-600 hover:stroke-red-400 focus:stroke-orange-600 focus:fill-orange-600'
                : 'fill-none stroke-slate-900 hover:stroke-orange-600 focus:stroke-slate-900';
        });

        const toggleFavorite = () => {
            hotelsStore.toggleToolFavorite(computedProperty.value, props.indie);

            if (computedProperty.value.isFavorite) {
                emit('removeFav');
            }
        };

        return { toggleFavorite, computedProperty, states };
    },
};
</script>
